<template>
  <!--
  作者：luoyiming
  时间：2019-10-24
  描述：信息公告
  -->
  <div>
    <!--nav start-->
    <div id="nav">
      <ul class="nav">
        <li :class="routerstr.indexOf('index')!=-1?'active':''" @click="pageClick('/index')">首页</li>
        <li :class="routerstr.indexOf('notice')!=-1?'active':''" @click="pageClick('/notice')">医院通知</li>
        <li :class="routerstr.indexOf('news')!=-1?'active':''" @click="pageClick('/news')">新闻中心</li>
        <li :class="routerstr.indexOf('message')!=-1?'active':''" @click="pageClick('/message')">信息公告</li>
        <li :class="routerstr.indexOf('department')!=-1?'active':''" @click="pageClick('/department')">科室介绍</li>
        <li :class="routerstr.indexOf('information')!=-1?'active':''" @click="pageClick('/information')">健康资讯</li>
        <li :class="routerstr.indexOf('contact')!=-1?'active':''" @click="pageClick('/contact')">联系我们</li>
      </ul>
    </div>
    <!--nav end-->
    <div class="message">
      <div class="message_title">信息公告</div>
      <div class="message_list">
        <!--start -->
        <div class="message_list_item" v-for="(item,index) in message" :key="index" @click="pageQueryClick('messagedetail',item.messageId)">
          <div class="message_list_item_text">{{item.title}}</div>
          <div class="message_list_item_time">{{item.createTime}}</div>
        </div>
        <!--start-->
      </div>

      <div>
        <Page :total="total" :page-size="limit" @on-change="pageChange" @on-prev="pagePrev" @on-next="pageNext" show-total prev-text="上一页" next-text="下一页"/>
      </div>
    </div>
  </div>
</template>

<script>
  import IndexApi from '@/api/index.js';
  export default {
    data() {
      return {
        routerstr:'/message',
        /*是否正在加载*/
        loading: true,
        /*背景图片*/
        bgimg_url: '',
        /*是否正在提交*/
        logining: false,
        /*基础配置*/
        total:0,
        page:1,
        limit:10,
        searchKey:'',
        message:[],

      };
    },
    created() {
      this.getMessage();
      this.routerstr = this.$router.currentRoute.path;
    },
    methods: {
      pageChange(e){
        this.page = e;
        this.getMessage();
      },
      pagePrev(e){
        this.page = e;
        this.getMessage();
      },
      pageNext(e){
        this.page = e;
        this.getMessage();
      },
      /*页面跳转*/
      pageClick(row) {
        this.$router.push(row);
      },
      /*页面跳转*/
      pageQueryClick(row,id) {
        this.$router.push({path:row,query:{id:id}});
      },
      getMessage() {
        let self = this;
        var data = {
          page:self.page,
          limit:self.limit,
          searchKey:self.searchKey,
        }
        IndexApi.messagelist(data,true)
          .then(res => {
            self.loading = false;
            self.message = res.data.list;
            self.total = res.data.total;
          })
          .catch(error => {
            self.loading = false;
          });
      },

    }
  };
</script>

<style lang="scss" scoped>
.message_title{height:150px;background: #007E4F;line-height: 150px;text-align: center;font-size:36px;color:#fff;font-weight: bold;}
  .message_list{
    width:1180px;margin:40px auto 40px;
    .message_list_item{
      height:99px;border-top:2px solid #DEDEDE;border-bottom:2px solid #DEDEDE;line-height: 99px;padding:0 30px;display: flex;justify-content: space-between;margin-bottom:20px;cursor: pointer;
      .message_list_item_text{
        width: 100%;height:99px;line-height: 99px;overflow: hidden;padding-right:40px;font-size:20px;
      }
      .message_list_item_time{
        width:200px;text-align: right;position: relative;font-size:18px;
      }
      .message_list_item_time::before{position: absolute;content:'';left:50px;bottom:45px;width:8px;height:8px;background: #999;border-radius: 8px;}
    }
  }
.ivu-page{margin:60px auto 0;width:700px;}
</style>



// WEBPACK FOOTER //
// src/views/message.vue